document.addEventListener('submit', async (e) => {
    if (e.target.id === 'formProduccionInyeccion') {
        e.preventDefault();
        const formulario = e.target;
        modalPadre = formulario.closest('.modal');
        const btnSubmit = formulario.querySelector('#btnGuardarReporteInyeccion');
        const spinner = formulario.querySelector('#spinner');
        const formData = new FormData(formulario);
        
        btnSubmit.disabled = true;
        spinner.style.display = 'inline-block';

        formulario.querySelectorAll('.inputRojo').forEach(input => input.classList.remove('inputRojo'));

        try {
            const respuesta = await fetch('/api/inyeccion/guardar-reporte-inyeccion', {
                method: 'POST',
                body: formData
            });
            const json = await respuesta.json();
            const status = respuesta.status;
            const resultado = json.result;
            
            if (status !== 200) {
                alert("Error crítico al procesar la solicitud, contacta al Administrador...");
                window.location.href = "/inyeccion";
                return;
            }

            if (resultado.hayErrores) {
                resultado.errores.forEach(error => {
                    lanzarAlerta(error.mensaje, error.clase);
                    const campo = formulario.querySelector(`[name="${error.campo}"]`);
                    if (campo) campo.classList.add('inputRojo');
                });
            } 
            if (!resultado.hayErrores) {
                const idReporte = formulario.querySelector('#idReporteInyeccion').value;
                var params = new URLSearchParams(window.location.search);
                var mes = params.get("mes");
                var año = params.get("año");
                formulario.reset();
                
                //if (modalPadre) modalPadre.classList.remove('modal--show');
                if (window.location.pathname === "/inyeccion/periodo") {
                    if (typeof window.actualizarModalReporteInyeccion === 'function') {
                        window.actualizarModalReporteInyeccion(idReporte);
                        window.actualizarTableroInyeccionPeriodo(mes, año);
                        window.actualizarTablaInyeccionPeriodo(mes, año);
                    }
                }
                if (window.location.pathname === "/zona-trabajo") {
                        if (window.location.pathname === "/zona-trabajo") window.actualizarZonaTrabajo();
                        window.actualizarModalReporteInyeccion(idReporte);
                    }
                lanzarAlerta("Registro guardado con éxito.", "alerta-verde");
            }

        } catch (error) {
            console.error("Error:", error);
            alert("Error crítico al procesar la solicitud, contactar al Administrador.");
            window.location.href = "/inyeccion";
        } finally {
            btnSubmit.disabled = false;
            spinner.style.display = 'none';
        }
    }
});